import { Link } from "react-router-dom"
import { FaArrowRight } from "react-icons/fa"

export default function ProductCard({ product }) {
return (
<article className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-gray-200 hover:shadow-xl transition-all duration-300">

  {/* Image */}
  <Link
    to={`/produits/${product.slug}`}
    aria-label={product.name}
    className="block overflow-hidden"
  >
    <img
      src={product.image}
      alt={product.name}
      loading="lazy"
      className="w-full aspect-square object-cover group-hover:scale-105 transition-transform duration-700"
    />
  </Link>

  {/* Contenu */}
  <div className="p-5">

    {/* Catégorie */}
    <span className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 text-gray-700 text-xs font-medium">
      {product.category}
    </span>

    {/* Nom */}
    <h3 className="mt-3 text-lg font-bold text-gray-900 line-clamp-2 min-h-[56px]">
      {product.name}
    </h3>

    {/* Description */}
    {product.shortDescription && (
      <p className="mt-2 text-sm text-gray-600 line-clamp-2">
        {product.shortDescription}
      </p>
    )}

    {/* Référence */}
    {product.reference && (
      <div className="mt-3 text-sm">
        <span className="text-gray-500">Référence :</span>{" "}
        <span className="font-medium text-gray-800">
          {product.reference}
        </span>
      </div>
    )}

    {/* Couleurs */}
    {product.colors?.length > 0 && (
      <div className="mt-4">
        <p className="text-xs font-medium text-gray-500 mb-2 uppercase tracking-wide">
          Couleurs
        </p>

        <div className="flex flex-wrap gap-2">
          {product.colors.slice(0, 6).map((color) => (
            <span
              key={color.name}
              title={color.name}
              className="w-6 h-6 rounded-full border border-gray-200"
              style={{
                backgroundColor: color.code,
              }}
            />
          ))}

          {product.colors.length > 6 && (
            <span className="flex items-center text-xs text-gray-500">
              +{product.colors.length - 6}
            </span>
          )}
        </div>
      </div>
    )}

    {/* Dimensions */}
    {product.sizes?.length > 0 && (
      <div className="mt-4">
        <p className="text-xs font-medium text-gray-500 mb-2 uppercase tracking-wide">
          Dimensions
        </p>

        <div className="flex flex-wrap gap-2">
          {product.sizes.slice(0, 3).map((size) => (
            <span
              key={size}
              className="px-2 py-1 rounded-md bg-gray-100 text-gray-700 text-xs"
            >
              {size}
            </span>
          ))}

          {product.sizes.length > 3 && (
            <span className="px-2 py-1 rounded-md bg-gray-100 text-gray-700 text-xs">
              +{product.sizes.length - 3}
            </span>
          )}
        </div>
      </div>
    )}

    {/* Bouton */}
    <Link
      to={`/produits/${product.slug}`}
      className="mt-6 inline-flex items-center gap-2 font-semibold text-blue-600 hover:text-blue-700 transition"
    >
      Voir le produit
      <FaArrowRight size={12} />
    </Link>

  </div>
</article>

)
}